import { CollectionPageEventTypes } from '../types';
import { createGrafanaEvent } from '../../../../../shared/utils/events/grafana/base';

const { header, itemTabs, sellerCard } = CollectionPageEventTypes;

export const CollectionPageGrafanaEvents = {
    [header.menu.clicked]: createGrafanaEvent('collection_page.header_menu.clicked'),
    [header.actions.shareWithTeam.clicked]: createGrafanaEvent(
        'collection_page.header_action_clicked.shared_with_team'
    ),
    [header.actions.socialShare.clicked]: createGrafanaEvent('collection_page.header_action_clicked.social_share'),
    [header.actions.edit.clicked]: createGrafanaEvent('collection_page.header_action_clicked.edit'),
    [header.actions.delete.clicked]: createGrafanaEvent('collection_page.header_action_clicked.delete'),
    [header.actions.copyCollection.clicked]: createGrafanaEvent(
        'collection_page.header_action_clicked.copy_collection'
    ),
    [header.actions.copyCollection.success]: createGrafanaEvent('collection_page.copy_collection.success'),
    [header.actions.copyCollection.fail]: createGrafanaEvent('collection_page.copy_collection.fail'),

    [itemTabs.tab.clicked]: createGrafanaEvent('collection_page.tab_clicked'),

    [sellerCard.clicked]: createGrafanaEvent('collection_page.seller_card_clicked'),
    [sellerCard.contact.clicked]: createGrafanaEvent('collection_page.seller_card.contact_clicked'),
    [sellerCard.availableServices.clicked]: createGrafanaEvent(
        'collection_page.seller_card.available_services_clicked'
    ),
};
